module.exports = __webpack_public_path__ + "static/media/document.9b7d9a33.png";